import React from 'react';
import PropTypes from 'prop-types';

const ProductTileMobile = ({ data }) => (
  <div className="product-tile">
    <a className="product-tile__link" target="_blank" href={data.links[0].deeplink}>
      <div className="product-tile__image" style={{ backgroundImage: `url(${data.imageSmall})` }} />
      <div className="product-tile__head">
        <span className="product-tile__headline" dangerouslySetInnerHTML={{ __html: data.headline ? data.headline : '' }} />
      </div>
    </a>
  </div>
);

ProductTileMobile.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ProductTileMobile;



// WEBPACK FOOTER //
// ./src/components/product/ProductTileMobile.js